import { ReactNode } from 'react'
import styled from '@emotion/styled'
import { FusionInterfaceZIndex } from '../../../theme/FusionStyle'
import { L1BaseShmoopie } from '../../interface/L1Shmoopie'

const AppHeaderRoot = styled.div(({theme}) => ({
	display: 'grid',
	gridTemplateColumns: '1fr',
	'@media print': {
		display: theme.isPrintMode ? 'none' : 'grid',
	},
}))

const Row1 = styled.div(({theme}) => ({
	display: 'flex',
	flexDirection: 'row',
	padding: '0.75rem 1.5rem',
	alignItems: 'center',
	backgroundColor: theme.colors.second,
	color: theme.colors.tableLabel,
	'> *': {
		zIndex: FusionInterfaceZIndex.Header,
	},
}))

const Row1PhantomLeft = styled.div({
	flex: '0 0 max-content',
	visibility: 'hidden',
	height: '1px',
	overflow: 'hidden',
})

// this gets centered by the parent <Row1 />,
// and then allows `baseline` to do its magic
const Row1Baseline = styled.div({
	flex: '1 1 auto',
	display: 'flex',
	flexDirection: 'row',
	alignItems: 'baseline',
	columnGap: '0.5rem',
})

const Row2 = styled.div(({theme}) => ({
	display: 'flex',
	flexDirection: 'row',
	justifyContent: 'center',
	backgroundColor: theme.colors.third,
	'> *': {
		zIndex: FusionInterfaceZIndex.Header,
	},
}))

interface V2L3AppHeaderProps {
	hasPhantomShmoopie?: boolean
	row1Children?: ReactNode
	row2Children?: ReactNode
}

export const V2L3AppHeader = ({
	hasPhantomShmoopie,
	row1Children,
	row2Children,
}: V2L3AppHeaderProps) => {
	return (
		<AppHeaderRoot>
			<Row1>
				{hasPhantomShmoopie ? (
					<Row1PhantomLeft>
						<L1BaseShmoopie />
					</Row1PhantomLeft>
				) : null}
				<Row1Baseline>
					{row1Children}
				</Row1Baseline>
			</Row1>
			{row2Children ? (
				<Row2>{row2Children}</Row2>
			) : null}
		</AppHeaderRoot>
	)
}
